import { UserFilled, VirtualAgentFilled } from "@aircall/icons";
import { Avatar, AvatarIcon, AvatarText, Tooltip } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import {
  SimpleSpeakerAvatarProps,
  SpeakerAvatarProps,
} from "./SpeakerAvatar.decl";
import { getTooltipContent } from "./SpeakerAvatar.utils";

import { useCall } from "@/hooks/useCall/useCall";

/**
 *
 * @returns Speaker Avatar with text or icon
 */
export function SimpleSpeakerAvatar({
  name,
  variant,
  isVirtualAgent,
  ...rest
}: SimpleSpeakerAvatarProps) {
  if (isVirtualAgent) {
    return (
      <Avatar size="small" variant={variant} {...rest}>
        <VirtualAgentFilled color="primary-500" size="16px" />
      </Avatar>
    );
  }

  return (
    <Avatar size="small" variant={variant} {...rest}>
      {name ? <AvatarText name={name} /> : <AvatarIcon icon={UserFilled} />}
    </Avatar>
  );
}

/**
 *
 * Render Speaker Avatar according to channel
 */
export function SpeakerAvatar({
  channel,
  shouldDisplayTooltip = true,
}: SpeakerAvatarProps) {
  const { t } = useTranslation();
  const { call } = useCall();

  const speaker = call?.speakers?.get(channel);
  if (!speaker) {
    return null;
  }

  const { variant, fullName, number, companyName, isVirtualAgent } = speaker;

  const trimmedFullName = fullName?.trim();

  const tooltipText = getTooltipContent(
    t,
    trimmedFullName,
    companyName,
    number
  );

  if (!shouldDisplayTooltip || !tooltipText) {
    return (
      <SimpleSpeakerAvatar
        name={trimmedFullName}
        variant={variant}
        isVirtualAgent={isVirtualAgent}
      />
    );
  }

  return (
    <Tooltip title={tooltipText} side="top" align="center">
      <Avatar size="small" variant={variant}>
        <SimpleSpeakerAvatar
          name={trimmedFullName}
          variant={variant}
          isVirtualAgent={isVirtualAgent}
        />
      </Avatar>
    </Tooltip>
  );
}
